import { allEventTypes, echartsEventsInEvent } from "utils/event"
import {getAttrById} from "vue-awesome-swiper/dist/exporter";
//初始化事件在组件中的事件监听逻辑(鼠标事件,组件事件),编辑页不执行
const variableRE = /\(\(((?:.|\r?\n)+?)\)\)/g
class EventControl {
  constructor(vue) {
    this.vue = vue
    this.myEvent = {}
    this.layoutColUid = ""
    this.oldOptionsMap = {}
  }
  /**
   * 将组件中的this,保存到事件功能的内部中,便于事件触发时获取组件变量、响应和触发组件的this、触发组件数据更新等,需要用到this的逻辑
   */
  bindContext(uid) {
    let uidStr
    let isColEvent = false
    if(uid){
      this.layoutColUid = uid
      uidStr = {uid:uid}
    }else if(this.vue.isCol){
      isColEvent = true
    }
    if(!isColEvent){
      this.vue.$event.addContext({ ...this.vue.myid, ...uidStr }, this.vue)
    }
  }
  //初始化
  init(uid) {
    this.bindContext(uid) //存储组件this
    if (this.vue.$route.path !== "/bigScreenPreview" && !this.vue.$route.path.includes("v2/p") && !window.isBigScreenPreviewUrl) return
    this.initEventTrigger()
  }
  //初始化组件的事件监听,包括鼠标事件、数据变化监听事件
  //这里用到了递归且递归次数不超过20,因为有可能在当前函数执行时组件的$el还没创建完成
  initEventTrigger(deep = 0) {
    let uidStr
    if(this.layoutColUid){
      uidStr = {uid: this.layoutColUid}
    }
    const { tar: myEvent, idsStr } = this.vue.$event.findTar({ ...this.vue.myid, ...uidStr })
    //首先需要获取组件$el用于绑定原生dom事件

    if(this.vue.$el.length < 1) return
    if (this.vue.$el) {
      const echarts = this.vue.$el.getElementsByClassName("echarts")[0]
      if (!myEvent) return //没有事件监听 就不用继续了
      this.myEvent = myEvent
      if (echarts) {
        //初始化echarts的事件触发器
        this.initEchartsEventTrigger()
      } else {
        //初始化普通组件的事件触发器
        this.initNormalEventTrigger()
      }
    } else if (deep < 20) {
      //dom没创建好,等待一下,再重新过去dom
      setTimeout(() => {
        this.initEventTrigger(deep + 1)
      }, 200)
    }
  }
  initEchartsEventTrigger() {
    //如果是图表组件 则先把图表组件的默认响应事件给加上,图表组件的事件监听不是进行原生dom的监听
    this.initEchartsMouseEvents()
    //首先初始化数据监听 echarts的事件监听不依赖于addEventListener 所以只监听监听数据变化
    //该组件的数据事件的描述对象
    const { dataEvents } = this.myEvent.events

    this.initDataEvents(dataEvents)
  }
  initEchartsMouseEvents() {
    //初始化图表组件的事件触发控制列表
    Object.keys(echartsEventsInEvent).forEach(eventName => {
      if (this.vue.eventCallbackList[eventName]) {
        if (!this.vue.eventCallbackList[eventName].find(it => it === echartsEventsInEvent[eventName][0])) {
          this.vue.eventCallbackList[eventName].push(...echartsEventsInEvent[eventName])
        }
      } else {
        this.vue.eventCallbackList[eventName] = echartsEventsInEvent[eventName]
      }
    })
  }
  initNormalEventTrigger() {
    //首先初始化监听，包括数据监听和鼠标事件监听
    //该组件的鼠标事件和数据事件的描述对象
    const { mouseEvents, dataEvents } = this.myEvent.events
    this.initMouseEvents(mouseEvents)
    this.initDataEvents(dataEvents)
  }
  /**
   * 初始化原生dom上的鼠标事件监听
   * @param {object} mouseEvents 当前组件的鼠标事件的事件行为描述
   */
  initMouseEvents(mouseEvents) {
    //先从mouseEventsTypes获取所有可能出现的鼠标事件,再去找当前组件对应有的鼠标事件
    allEventTypes.mouseEventsTypes.forEach(event => {
      //有长度 证明有注册该类型事件 例如mouseEvents[event.value] =》click
      if (mouseEvents[event.value]?.length) {
        this.myEvent[event.value] = mouseEvents[event.value]
        if (this.fixEventName(event.value) === "hover") {
          //鼠标悬停事件特殊处理
          this.initHoverEvent()
        } else {
          //触发该类型事件的事件监听
          //通过this[event.value],来触发预设的鼠标事件处理函数,例如click,dbclick,mouseover,moseenter等
          this.vue.$el.addEventListener(this.fixEventName(event.value), this[event.value], false)
        }
      }
    })
  }
  /**
   * 鼠标悬停事件的处理分为鼠标进入时、和鼠标出去时
   */
  initHoverEvent() {
    //增加鼠标进入时的事件监听,并且记录悬浮时需要改变的样式的当前数据到oldOptionsMap,便于鼠标移出时还原
    this.onMouseEnterBind = this.onMouseEnter.bind(this)
    this.vue.$el.addEventListener("mouseenter", this.onMouseEnterBind, false)
    //鼠标移出时,利用事件触发的triggerEvent方法,将之前存储的变化前的配置项覆盖现有的配置项
    this.onMouseLeaveBind = this.onMouseLeave.bind(this)
    this.vue.$el.addEventListener("mouseleave", this.onMouseLeaveBind, false)
  }
  //初始化 监听组件数据变化后触发的事件的监听器
  initDataEvents(dataEvents) {
    const { anyDataChange, appointDataChange } = dataEvents
    //如果有任意数据变化时执行的事件监听 才会新增事件侦听器
    if (anyDataChange.length) {
      const _self = this
      this.vue.$watch(
        "options",
        function () {
          console.log("opt change")
          anyDataChange.forEach(ev => _self.triggerEvent(ev, "anyDataChange"))
        },
        { deep: true }
      )
    }
    //如果有指定数据变化时执行的事件监听 才会新增事件侦听器
    if (appointDataChange.length) {
      const _self = this
      //遍历每一个需要监听的数据改变事件,依次进行监听
      let newKeysArr = []
      appointDataChange.forEach(event => {
        //同一个变量监听事件可能存在同时监听多个变量的场景,例如:
        //场景1: 变量1改变时触发
        //场景2: 变量1 > 100 时触发
        //场景3: 变量1>50 且 变量2 >50 时触发
        //场景4: 变量1>60 或 变量2 >40 时触发
        const execVariableKeys = Object.keys(event.variableTag).filter(k =>
          event.variableTag[k].hasOwnProperty("triggerType")
        )
        let type = execVariableKeys.map(it => event.variableTag[it].triggerType)
        let ifImmediate = false,
          berforeE = event.lifeCycle.beforeTrigger, delayTime = 0
        if (berforeE.length > 0) {
          berforeE.forEach(item => {
            /* 事件触发前添加了插件immediateTrue：一进入页面就执行一次 */
            if (item.pluginName === "immediateTrue") {
              if (type.indexOf("change") < 0) {
                ifImmediate = true
              } else {
                /*改变的事件立即执行一次*/
                // setTimeout(() => {
                //   _self.triggerEvent(event, "appointDataChange", { 默认: [event] })
                // }, 100)
              }
            }
          })
        } else if (event.action) {
          /* 显隐事件默认一进入页面就执行一次 */
          if (type.indexOf("change") < 0) {
            ifImmediate = true
            delayTime = 300
          } else {
            /*改变的事件立即执行一次*/
            _self.triggerEvent(event, "appointDataChange", { 默认: [event] })
          }
        }

        this.vue.$watch(
          () => {
            return execVariableKeys.map(it => this.vue.hasProperty(this.vue.options, event.variableTag[it].path))
          },
          function (newVal, oldVal) {
            //execVariableKeys有长度 则证明有需要检测是否满足条件的事件
            if (execVariableKeys.length) {
              if (_self.checkWatcher(event, execVariableKeys, newVal, oldVal)) {
                setTimeout(() => {
                  _self.triggerEvent(event, "appointDataChange", { 默认: [event] })
                  delayTime = 0
                }, delayTime)
              }
            } else {
              _self.triggerEvent(event, "appointDataChange")
            }
          },
          { immediate: ifImmediate }
        )
      })
    }
  }
  /**
   * 检查所监听的值是否符合预设
   * @param {object} event 当前组件的事件描述
   * @param {object} execVariableKeys 当前事件所用监听的值
   * @param {any} newVal 改变后的值
   * @param {any} oldVal 改变前的值
   * @returns {boolean} 置否符合预设的条件
   */
  checkWatcher(event, execVariableKeys, newVal, oldVal) {
    const { from, path, variableTag } = event
    let status = ""
    execVariableKeys.forEach((k, index) => {
      const tag = variableTag[k]
      let { matchStr, mode, matchType, path, triggerType } = tag
      matchType = matchType || ""
      matchType = matchType.replaceAll("&lt;", "<").replaceAll("&gt;", ">")
      //执行器条件,会出现以下需要校验的场: 变量 > 1 && 变量2 <50 || 变量3 >100
      //分别获取每一个变量的执行结果,例如 变量1 > 1 的执行结果,然后再进行 且/或 的判定
      if (triggerType === "exec") {
        const tarVariableVal = this.vue.hasProperty(this.vue.options, path)
        const variables = matchStr.match(variableRE)?.map(it => it.slice(2, -2))
        if (variables?.length) {
          //处理匹配字符串中的变量值
          variables.forEach(variableName => {
            matchStr = matchStr.replaceAll(
              `((${variableName}))`,
              this.vue.hasProperty(this.vue.options, variableTag[variableName].path)
            )
          })
        }
        const type = Object.prototype.toString.call(tarVariableVal).slice(8, -1)
        //根据目标变量的值,进行预设的多条件满足的判断
        status += eval(`${this.fixType(tarVariableVal, type)}${matchType}${this.fixType(matchStr, type)}`)
      } else {
        status += newVal[index] !== oldVal[index]
      }
      if (index !== execVariableKeys.length - 1) {
        status += mode
      }
    })
    return eval(status)
  }
  fixType(val, type) {
    switch (type) {
      case "String":
        return `"${val}"`
      case "Boolean":
        return Boolean(val)
      case "Number":
        return Number(val)
      case "Null":
        return null
      case "undefined":
        return undefined
      case "Array":
        return Array.from(val)
      case "Object":
        return Object(val)
      default:
        return val
    }
  }
  hover = e => this.handleMouseEvent(e, "hover")
  click = e => this.handleMouseEvent(e, "click")
  dblclick = e => this.handleMouseEvent(e, "dblclick")
  mouseover = e => this.handleMouseEvent(e, "mouseover")
  mouseout = e => this.handleMouseEvent(e, "mouseout")
  mousedown = e => this.handleMouseEvent(e, "mousedown")
  mouseup = e => this.handleMouseEvent(e, "mouseup")
  //移动端事件
  touchstart = e => this.handleMouseEvent(e, "touchstart")
  touchend = e => this.handleMouseEvent(e, "touchend")
  //统一处理dom上的原生鼠标事件的地方
  handleMouseEvent(e, type) {
    //需要阻止当前鼠标事件的冒泡,因为有些组件是在自由布局组件的单元格里的,会冒泡到触发自由布局组件本身的当前鼠标事件
    e.stopPropagation && e.stopPropagation()
    this.triggerEvent(e, type)
  }
  isCurr(e) {
    if (e.target && e.currentTarget) {
      //必须得是当前元素触发的 不能是别的元素冒泡的或者捕获的
      return e.target === e.currentTarget
    } else return true
  }
  /**
   *触发当前组件的当前事件
   * @param {Object} ev 一个描述当前事件的对象
   * @param {EventListenerObject} e 浏览器事件对象,监听数据变化触发的事件是没有该属性的
   * @param {object} evs 获取到的事件组对象
   */
  triggerEvent(e, type, evs) {
    const events = evs || this.getCurrEvents(type)
    for (const key in events) {
      if (Object.hasOwnProperty.call(events, key)) {
        const evs = events[key]
        //异步的执行每一组的事件
        this.triggerEventsGroup(e, evs)
      }
    }
  }
  /**
   * 根据事件类型 将成组的事件分类
   * 例如鼠标单击时,需要同时触发10个事件,这10个事件中,前五个是一组,后五个是一组,每组之间的处理互不干涉,例如组1的事件中有耗费时间的事件,不会影响组2事件的执行
   * @param {string} type 事件类型 鼠标事件或数据事件
   * @returns
   */
  getCurrEvents(type) {
    const events = {}
    this.myEvent?.events?.[type.includes("Data") ? "dataEvents" : "mouseEvents"][type].forEach(ev => {
      if (!events.hasOwnProperty(ev.groupId)) events[ev.groupId] = []
      events[ev.groupId].push(ev)
    })
    return events
  }
  //对当前组的事件进行执行,并且当前组中的事件某一个为异步事件时,需要做等待,等当前事件执行完成后再继续执行
  async triggerEventsGroup(e, evs) {
    for (let i = 0; i < evs.length; i++) {
      let ev = evs[i]
      await this.vue.$event.trigger(ev, e)
    }
  }
  //在组件销毁时,移出dom上的事件监听的处理函数
  removeEventTrigger() {
    if (this.vue.$route.path !== "/bigScreenPreview" && !this.vue.$route.path.includes("v2/p") && !window.isBigScreenPreviewUrl) return
    //如果事件中没有注册该组件的事件 则不需要进行事件移出
    if (!this.myEvent) return
    const echarts = this.vue.$el.getElementsByClassName("echarts")[0]
    if (echarts) {
      //移除echarts的事件触发器
      this.removeEchartsEventTrigger()
    } else {
      //移除普通组件的事件触发器
      this.removeNormalEventTrigger()
    }
    this.vue.$el.removeEventListener("mouseenter", this.onMouseEnterBind, false)
    this.vue.$el.removeEventListener("mouseleave", this.onMouseLeaveBind, false)
  }
  removeEchartsEventTrigger() {
    //暂时还不知道echarts需要移除什么
  }
  removeNormalEventTrigger = () => {
    //移除addEventListener时添加的事件监听 以防止内存溢出
    allEventTypes.mouseEventsTypes.forEach(item => {
      this.vue.$el.removeEventListener(this.fixEventName(item.value), this[item.value], false)
    })
  }
  fixEventName(name) {
    let eventName = name
    switch (eventName) {
      case "mouseover":
        eventName = "mouseenter"
        break
      case "mouseout":
        eventName = "mouseleave"
        break

      default:
        break
    }
    return eventName
  }
  onMouseEnter(e) {
    //用于记录鼠标移入前，没有被鼠标移入事件修改时的options，并将其用事件的数据结构保存起来
    this.oldOptionsMap = {}
    const hoverEvents = JSON.parse(JSON.stringify(this.getCurrEvents("hover") || {}))
    for (let k in hoverEvents) {
      hoverEvents[k].forEach(evs => {
        if (evs.eventMovement === "component" && evs.movementType === "options") {
          //将原有的配置项放到oldOptionsMap,并把数据结构写成事件触发时可识别的数据结构,便于鼠标移出时还原事件
          if (this.oldOptionsMap[k] === undefined) {
            this.oldOptionsMap[k] = []
          }
          const ids = this.vue.myid
          const stage = this.vue.$store.state[this.vue.request_prefix]
          const rectAttr = this.vue.getAttrById(stage, ids)
          const opt = rectAttr.options ? rectAttr.options : rectAttr
          if (evs.update.type === "force") {
            //如果有事件参数变量并且事件参数变量为有效值 则把事件参数变量格式化为普通参数变量
            evs.update.option = opt
          } else {
            evs.update.option.forEach(it => {
              it.value = this.vue.hasProperty(opt, it.path)
            })
          }
          this.oldOptionsMap[k].push(evs)
        }
      })
    }
    this.hover(e)
  }
  onMouseLeave(e) {
    this.triggerEvent(e, null, this.oldOptionsMap)
  }
}

export default {
  data() {
    return {
      eventControl: new EventControl(this)
    }
  },
  mounted() {
    if(this.options.eventImmediateTrue === true){
      if(this.options.innerElement === "cxText"){
        this.options.content = ""
      }
      if(this.options.eventImmediateTrueIdsArr && this.options.eventImmediateTrueIdsArr.length > 0){
        let eventQuery1 = ""
        this.options.eventImmediateTrueIdsArr.forEach((item, index)=>{
          let ids1 = JSON.parse(item)
          let from1 = this.getAttrById.call(this, this.$store.state[this.request_prefix], ids1)
          //  判断是否有指定路径：默认获取value值，为了解决变量路径不是value的情况
          let { idsStr } = this.$event.findTar({
            pageId: this.myid.pageId,
            container_id: ids1.container_id,
            rect_id: ids1.rect_id,
          })
          let tarEvent = this.$event.eventBus.stage[idsStr], tarEventPath = "value"
          let appointDataChangeArr = tarEvent.events.dataEvents.appointDataChange
          if(appointDataChangeArr.length > 0){
            for(let i=0;i<appointDataChangeArr.length;i++){
              if(appointDataChangeArr[i].ids.pageId === this.myid.pageId
                  && appointDataChangeArr[i].ids.container_id === this.myid.container_id
                  && appointDataChangeArr[i].ids.rect_id === this.myid.rect_id){
                for(let key in appointDataChangeArr[i].variableTag){
                  tarEventPath = appointDataChangeArr[i].variableTag[key].path
                }
              }
            }
          }
          if(index === 0){
            eventQuery1 = from1.options[tarEventPath]
          }else{
            eventQuery1 = eventQuery1 + "###" + from1.options[tarEventPath]
          }
        })
        this.options.eventQuery = eventQuery1
      }
    }
    if(this.options?.queryColValue && this.colsOptions){
      let last1 = this.findLastColLayout(this.colsOptions)
      if(last1){
        setTimeout(()=>{
          if(last1.elementOptions?.length > 0){
            this.eventControl.init(last1.uid)
          }
        }, 500)
      }
    }else{
      this.eventControl.init()
    }
  },
  methods: {
    findLastColLayout(options){
      let lastLeaf = options
      while (lastLeaf.rows || lastLeaf.cols) {
        lastLeaf = lastLeaf.rows ? lastLeaf.rows[0] : lastLeaf.cols[0]
      }
      return lastLeaf
    }
  },
  beforeDestroy() {
    this.eventControl.removeEventTrigger()
  }
}
